import Vue from 'vue';
import solarLunar from 'solarlunar';
import moment from 'moment';

import cardStatus from '@constants/card/status';

Vue.filter('encrypt', (value, type) => {
  if (/^\d{11}$/.test(value) && type === 'phone') {
    return (value + '').replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');
  } else if (type === 'name') {
    return value.slice(0, 1) + '**';
  }
  return value;
});

Vue.filter('money', (value) => {
  if (isNaN(value) || value === null) {
    return '--';
  }
  return (+value / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});
// 转化百分比
Vue.filter('percentage', (value) => {
  if (isNaN(value) || value === null) {
    return '--';
  }
  return Math.abs((+value / 100).toFixed(2)) + '%';
});
//过滤展示虚拟卡号
Vue.filter('virtualCard',(value) =>{
  if (value.length >= 27){
    let mobile = value.substring(value.length -11);
    let randomNum = value.substring(12,16);
    return mobile + randomNum;
  } else {
    return value;
  }
});
//卡状态转换
Vue.filter('cardStatus', (value) => {
  return cardStatus[value] || '--';
});
//时间戳转换(毫秒)
Vue.filter('timeReturn', (value, type = '') => {
  value = +value;
  switch (type) {
    case '':
      if (value === 0){
        return '--';
      } else {
        return moment(Number(value)).format('YYYY-MM-DD HH:mm:ss') || '--';
      }
    case 'D':
    case 'd':
    case 'day':
    case 'Day':
      return value ? moment(+value).format('YYYY-MM-DD') : '--';
    default:
      return value;
  }
});
//有无数据显示
Vue.filter('valueHav', (value) => {
  if (isNaN(value) || value === null){
    return '--';
  } else {
    return value;
  }
});
// 阳历转阴历
Vue.filter('solarToLunar', (val) => {
  let lunarDate = '';
  if (val) {
    let year = moment(Number(val)).year();
    let month = moment(Number(val)).month() + 1;
    let day = moment(Number(val)).date();
    let lunarDateObj = solarLunar.solar2lunar(year, month, day);
    lunarDate = `${lunarDateObj.lYear}年${lunarDateObj.monthCn}${lunarDateObj.dayCn}`;
  }
  return lunarDate;
});
// 会员名长度限制
Vue.filter('memName', val => {
  if (val) {
    if (val.length <= 10) {
      return val;
    } else {
      val = val.toString();
      val = `${val.substr(0, 10)}...`;
      return val;
    }
  } else {
    return val;
  }
});

Vue.filter('people', val => {
  return (val === 0 || val) ? val : '--';
});

//活动类型转换
Vue.filter('activityType', (type) => {
  switch (type) {
    case 1:
      return '开卡赠券';
    case 2:
      return '消费满额赠券';
    case 3:
      return '储值赠券';
    case 4:
      return '生日赠券';
    case 5:
      return '精准营销';
    case 6:
      return '红包活动';
    case 7:
      return '定食营销';
    default:
      return type;
  }
});
//活动状态转换
Vue.filter('activityStatus', (type) => {
  switch (type) {
    case 1:
      return '未开始';
    case 2:
      return '进行中';
    case 3:
      return '已结束';
    case 4:
      return '已终止';
    default:
      return type;
  }
});



// WEBPACK FOOTER //
// ./src/components/core/registerFilter.js